export const SHOW_HELP_TEXT = 'SHOW_HELP_TEXT';
export const REQUEST_HELP_TEXT = 'REQUEST_HELP_TEXT';
export const FAILED_TO_RECEIVE_HELP_TEXT = 'FAILED_TO_RECEIVE_HELP_TEXT';
export const RECEIVE_HELP_TEXT = 'RECEIVE_HELP_TEXT';
